import {createStore} from 'vuex'
import auth from './modules/auth'
import pvp from './modules/pvp'
import season from './modules/season'
import messages from './modules/messages'
import daily from './modules/daily'
import tutorial from './modules/tutorial'

const store = createStore({
  state() {
    return {
      info: null
    }
  },
  modules: {
    auth,
    pvp,
    season,
    messages,
    daily,
    tutorial
  }
})

export default store
